/**
 * Kurzschreibweisen / Hilfsfunktionen für ThreeJS
 * @example
 * import {v3,v2,quat} from 'oc-threejs/short3.js';
 * const myVector = v3(1,2,3);
 */


/**
 * Kurzschreibweise für new THREE.Vector3(x, y, z)
 */
export function v3 (x = 0, y = 0, z = 0) {
    if (x instanceof THREE.Vector3) {
        return x.clone();
    }
    if (_.isNumber(x)) {
        return new THREE.Vector3(x, y, z);
    }
    const v = new THREE.Vector3();
    if (x) {
        v.copy(x);
    }
    return v;
}

/**
 * Kurzschreibweise für new THREE.Vector2(x, y)
 */
export function v2 (x = 0, y = 0) {
    if (x instanceof THREE.Vector2) {
        return x.clone();
    }
    if (_.isNumber(x)) {
        return new THREE.Vector2(x, y);
    }
    const v = new THREE.Vector2();
    if (x) {
        v.copy(x);
    }
    return v;
}

/**
 * Erzeugt ein Quaternion (x,y,z,angle) wobei angle in Grad ist.
 * Dabei steht x,y,z für eine Rotationsachse und angle für die Rotation um diese Achse
 */
export function quat(x, y, z, angle) {
    if (x == null) {
        return new THREE.Quaternion();
    }
    return new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(x, y, z), angle * Math.PI / 180);
}

/**
 * Erzeugt ein Quaternion aus einer Euler-Rotation (x,y,z,'XYZ') wobei alle Winkel in Grad sind.
 */
export function quatEuler(x = 0, y = 0, z = 0, order = 'XYZ') {
    const r = Math.PI/180;
    return new THREE.Quaternion().setFromEuler(new THREE.Euler( x*r, y*r, z*r, order ));
}
